import { render, staticRenderFns } from "./StudioCommunityChat.vue?vue&type=template&id=1b3231eb&scoped=true&"
import script from "./StudioCommunityChat.vue?vue&type=script&lang=js&"
export * from "./StudioCommunityChat.vue?vue&type=script&lang=js&"
import style0 from "./StudioCommunityChat.vue?vue&type=style&index=0&id=1b3231eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3231eb",
  null
  
)

export default component.exports